import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';

import { SHARING_ORIGIN } from '#src/config.ts';
import { getPrefix } from '#src/lib/i18n.ts';
import {
  getHrefLangUrls,
  getLocalizedUrl,
} from '#src/lib/seo/localizedUrls.ts';

type Props = {
  /** Lists every language when undefined. */
  languages?: readonly string[];
};

export const HrefLang = ({ languages }: Props) => {
  const { pathname } = useLocation();
  const { locale } = useIntl();

  return (
    <Helmet>
      {getHrefLangUrls(SHARING_ORIGIN, pathname, languages).map(
        ({ hrefLang, href }) => (
          <link
            key={hrefLang}
            hrefLang={hrefLang}
            href={href}
            rel="alternate"
          />
        )
      )}
      <link
        href={getLocalizedUrl(SHARING_ORIGIN, getPrefix(locale), pathname)}
        rel="canonical"
      />
    </Helmet>
  );
};
